// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetDigitalAssetsRequestModel from '../../model/get-digital-assets-request-model';
import GetDigitalAssetsRequestDTO from '../dto/get-digital-assets-request-dto';
import dtoSchema from '../schemas/get-digital-assets-request-schema';

export default abstract class GetDigitalAssetsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetDigitalAssetsRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.id = data.id;
      this.filename = data.filename;
      this.extension = data.extension;
      this.isAssigned = data.isAssigned;
      this.isSold = data.isSold;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  filename?: string;
  /**
  */
  extension?: string;
  /**
  */
  isAssigned?: boolean;
  /**
  */
  isSold?: boolean;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetDigitalAssetsRequestDTO>): GetDigitalAssetsRequestModel;
  static toModel(dto: DeepPartial<GetDigitalAssetsRequestDTO> | undefined | null): GetDigitalAssetsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetDigitalAssetsRequestDTO> | undefined | null): GetDigitalAssetsRequestModel | undefined {
    return dto ? new GetDigitalAssetsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetDigitalAssetsRequestModel> | GetDigitalAssetsRequestModel): GetDigitalAssetsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      id: unwrapped.id,
      filename: unwrapped.filename,
      extension: unwrapped.extension,
      isAssigned: unwrapped.isAssigned,
      isSold: unwrapped.isSold,
      searchCriteria: unwrapped.searchCriteria,
    } as GetDigitalAssetsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetDigitalAssetsRequestModel, can not map to GetDigitalAssetsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
